import Registration from './Registration.vue'

export default Registration